import * as _ from "lodash";
import PropTypes from "prop-types";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";

import actions from "@/actions";
import { Wizard } from "@/components";
import { MapSettings } from "@/models";

import Steps from "./steps";

const MapSettingsCreate = ({ mapSettings, resetHistory, save }) => {
    const [settings, setSettings] = useState(mapSettings);
    const validationRef = useRef({});

    const stepRefs = useMemo(
        () => _.mapValues(Steps, () => ({ current: null })),
        [],
    );

    useEffect(() => {
        return () => {
            resetHistory();
        };
    }, [resetHistory]);

    const handleSave = useCallback(() => {
        const instance = new MapSettings(settings.dataAPI || {});
        if (settings.spaceDetails)
            instance.spaceDetails = settings.spaceDetails;
        if (settings.fixtureDetails)
            instance.fixtureDetails = settings.fixtureDetails;
        if (settings.ceilingDetails)
            instance.ceilingDetails = settings.ceilingDetails;
        if (settings.geoTransform)
            instance.geoTransform = settings.geoTransform;
        save(instance);
    }, [save, settings]);

    const onValidateStep = useCallback(
        (stepName, updateCall) => {
            let validate;
            if (!updateCall) {
                validationRef.current[stepName] = true;
            }
            if (!updateCall || validationRef.current[stepName]) {
                const stepRef = stepRefs[stepName].current;
                validate = stepRef.validate();
            }
            return validate;
        },
        [stepRefs],
    );

    const onSettingsChanged = useCallback(
        (settingsId, newSettings) => {
            setSettings((prevSettings) => {
                const id = `${settingsId}Details`;
                return {
                    ...prevSettings,
                    [id]: {
                        ...prevSettings[id],
                        ...newSettings,
                    },
                };
            });
            onValidateStep(settingsId, true);
        },
        [onValidateStep],
    );

    const steps = _.map(Steps, (Step, stepName) => ({
        title: _.capitalize(`${stepName} Details`),
        id: stepName,
        component: (
            <Step
                name={_.camelCase(`${stepName}Details`)}
                ref={stepRefs[stepName]}
                state={settings[_.camelCase(`${stepName}Details`)]}
                onChangeState={(state) => onSettingsChanged(stepName, state)}
            />
        ),
        validate: true,
    }));

    return (
        <Wizard
            steps={steps}
            onValidateStep={onValidateStep}
            onSubmit={handleSave}
            submitTextButton="Create Map"
        />
    );
};

MapSettingsCreate.propTypes = {
    mapSettings: PropTypes.any,
    resetHistory: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired,
};

const mapStateToProps = ({ map }) => ({
    mapSettings: map.general.settings,
});
const mapDispatchToProps = {
    resetHistory: actions.map.values.global.setInitHistory,
    save: actions.map.general.saveSettings,
};
export default connect(mapStateToProps, mapDispatchToProps)(MapSettingsCreate);
